<template>
  <div class="profile-selector">
    <div class="selected-profile" v-if="modelValue">
      <ProfileCard :person-id="modelValue" select-mode show-profile-type :disabled="disabled" @click="removeSelectedPerson"/>
    </div>
    <div v-else>
      <SearchInput ref="searchInputRef" 
        v-model="searchTextRef" 
        :search-results="profileSearchResultsRef" 
        :placeholder="placeholderRef"
        :disabled="disabled"
        v-slot="{ item }"
        @focus="emit('focus')"
        @result-selected="searchResultSelected">
        <ProfileCard :person-id="item.id" show-profile-type select-mode flat/>
      </SearchInput>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.profile-selector {
  min-height: 40px;
}

.profile-card {
  min-width: 350px;

  @media (min-width: 768px) {
    min-width: 400px;
  }
}
</style>

<script lang="ts" setup>
import { computed, nextTick, ref } from 'vue'
import { useLivePersonSearch } from '@/rd/LivePersonSearch'
import { usePersonStore } from '@/rd/PersonStore'
import ProfileCard from '@/manage/ProfileCard.vue'
import SearchInput from "@/util/SearchInput.vue"

const props = defineProps<{
  modelValue: string | undefined
  placeholder?: string
  disabled?: boolean
}>()

const emit = defineEmits([
  'update:modelValue',
  'focus'
])

defineExpose({
  focus: () => searchInputRef.value?.focus(),
  reset
})

const removeButtonRef = ref<HTMLButtonElement>()
const searchInputRef = ref<InstanceType<typeof SearchInput>>()
const { searchTextRef, searchResultsRef } = useLivePersonSearch()

const personStore = usePersonStore()

const placeholderRef = computed(() => props.placeholder ?? "Type a name")
const profileSearchResultsRef = computed(() => 
  searchResultsRef.value.flatMap(vp => personStore.getLoadedPersonList(vp.matchIds).filter(p => p.profile && !p.placeholder)))

async function searchResultSelected(id: string) {
  emit('update:modelValue', id)
  await nextTick()
  removeButtonRef.value?.focus()
}

async function removeSelectedPerson() {
  emit('update:modelValue', undefined)
  await nextTick()
  searchInputRef.value?.focus()
}

function reset() {
  searchTextRef.value = ""
  searchInputRef.value?.reset()
}
</script>
